import ResponsiveHelper from "../utils/ResponsiveHelper";
import Swiper from "swiper/bundle";

import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

export default class Homepage {
  constructor(dom) {
    this.dom = dom;
    window.addEventListener("resize", () => this.resize());
  }
  init() {
    gsap.registerPlugin(ScrollTrigger);
    this.initResponsiveHelper();
    this.initTopSlider();
    this.initSectionControl();
  }

  initResponsiveHelper() {
    this.rHelper = new ResponsiveHelper();
    window.addEventListener("onBreakpointChange", (e) => {
      //console.log(e.detail);
    });
  }

  initTopSlider() {
    const hmSlider = this.dom.querySelector("[js-hm-slider]");
    if (hmSlider) {
      new Swiper(hmSlider, {
        // Default parameters
        slidesPerView: 1.25,
        spaceBetween: 10,
        // speed: 800,
        autoplay: {
          delay: 2500,
        },
        // Responsive breakpoints
        breakpoints: {
            // 768: {
            //     slidesPerView: 2.25,
            //     spaceBetween: 10,
            //     autoplay: {
            //         delay: 2500,
            //     },
            // },
            968: {
                // slidesPerView: 2.65,
                // slidesPerView: 'auto',
                slidesPerView: 3,
                spaceBetween: 10,
                autoplay: {
                    delay: 5000,
                },
            },
        },
        navigation: {
          nextEl: ".hm-slider--btn__next",
          prevEl: ".hm-slider--btn__prev",
        },
      });
    }
  }
  initSectionControl() {
    let panels = gsap.utils.toArray(".hm-sec");

    let tops = panels.map((panel) =>
      ScrollTrigger.create({ trigger: panel, start: "top top" })
    );

    panels.forEach((panel, i) => {
  
            ScrollTrigger.create({
                trigger: panel,
                start: () => {
                    // if (window.innerWidth < 768) {
                    //     return "bottom bottom"; // on mobile, we always pin at the top
                    // }
                    return panel.offsetHeight < window.innerHeight ? "top top" : "bottom bottom"; // if it's shorter than the viewport, we prefer to pin it at the top
                },
                pin: window.innerWidth >= 768 ? true : i == panels.length - 1 ? false : true,
                pinSpacing: false,
                duration: 0,
                // markers: true,
            });
        
    });

    // ScrollTrigger.create({
    //   snap: {
    //     snapTo: (progress, self) => {
    //       let panelStarts = tops.map((st) => st.start), // an Array of all the starting scroll positions. We do this on each scroll to make sure it's totally responsive. Starting positions may change when the user resizes the viewport
    //         snapScroll = gsap.utils.snap(panelStarts, self.scroll()); // find the closest one
    //       return gsap.utils.normalize(
    //         0.5,
    //         ScrollTrigger.maxScroll(window),
    //         snapScroll
    //       ); // snapping requires a progress value, so convert the scroll position into a normalized progress value between 0 and 1
    //     },
    //     duration: 0.3,
    //   },
    // });
  }
  resize() {
    // console.log("resize from Homepage.js");
  }
}
